import { render, staticRenderFns } from "./GrowthYear.vue?vue&type=template&id=6076f948&scoped=true&"
import script from "./GrowthYear.vue?vue&type=script&lang=js&"
export * from "./GrowthYear.vue?vue&type=script&lang=js&"
import style0 from "./GrowthYear.vue?vue&type=style&index=0&id=6076f948&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6076f948",
  null
  
)

export default component.exports